import React, { useEffect, useState } from "react";
import MenuTab from "./tabs/MenuTab";
import TabMenu from "../atoms/TabMenu";
import RecipeBanner from "./RecipeBanner";
import MoreInfoTab from "./tabs/MoreInfoTab";
import DownloadTab from "./tabs/DownloadTab";
import CertifiedTab from "./tabs/CertifiedTab";
import IngredientsTab from "./tabs/IngredientsTab";
import RecipeDescription from "./RecipeDescription";
import { buildApiUrl, endpoints } from "../../config/endpoints";
import { get } from "../../services/apiService";

interface RecipeDetailsProps {
  recipeUuid: string;
}

interface Recipe {
  uuid: string;
  name: string;
  description: string;
}

const RecipeDetails: React.FC<RecipeDetailsProps> = ({ recipeUuid }) => {
  const [recipe, setRecipe] = useState<Recipe | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchItemDetails = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await get<Recipe>(
          buildApiUrl(endpoints.recipeDtails, { recipeUuid })
        );
        setRecipe(result);
      } catch (error: any) {
        setError(error.message || "An error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchItemDetails();
  }, [recipeUuid]);

  const tabs = [
    { label: "Menu", content: <MenuTab /> },
    { label: "More Infos", content: <MoreInfoTab /> },
    { label: "Ingredients", content: <IngredientsTab /> },
    { label: "Download", content: <DownloadTab /> },
    { label: "Cerified", content: <CertifiedTab /> },
  ];
  return (
    <>
      <RecipeBanner />
      <div className="main-container">
        <RecipeDescription
          title={
            recipe?.name || "Mixed Green Salad with Sweet & Spicy Horseradish"
          }
          description={
            recipe?.description ||
            ` The inspiration for this dressing struck me during my journey in
            Croatia. In a quaint village adorned with a makeshift tavern,
            horseradish was, The inspiration for this dressing struck me during
            my journey in Croatia. In a quaint village adorned with a makeshift
            tavern.`
          }
        />
        <TabMenu tabs={tabs} />
      </div>
    </>
  );
};

export default RecipeDetails;
